// import * as faceapi from 'face-api.js';
import * as faceapi from "@vladmandic/face-api";
// import { STATE, setBackendAndEnvFlags } from "../shared";
import { Face } from "hooks";

interface IFacial {
  label: string;
  descriptors: Float32Array[];
}

export interface IFaceMatch {
  match: faceapi.FaceMatch;
  detection: faceapi.WithFaceDescriptor<
    faceapi.WithFaceLandmarks<
      {
        detection: faceapi.FaceDetection;
      },
      faceapi.FaceLandmarks68
    >
  >;
}

// const modelUri = "https://cdn.jsdelivr.net/gh/cgarciagl/face-api.js@0.22.2/weights";

// export const faceWorker = new Worker('/faceWorker.js');

export class FaceApiModels {
  static init() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    Promise.all([
      // faceapi.nets.faceExpressionNet.loadFromUri(modelUri),
      // faceapi.nets.tinyFaceDetector.loadFromUri(modelUri),
      // faceapi.nets.faceLandmark68Net.loadFromUri(modelUri),
      // faceapi.nets.faceRecognitionNet.loadFromUri(modelUri),
      // setBackendAndEnvFlags(STATE.flags, STATE.backend),
      Face.init(),
    ])
      .then(() => {
        console.log("Model Loaded");
      })
      .catch((err) => {
        console.error("Model Loading failed", err);
      });
  }
}

export class FacialRecoganization {
  private faceMatcher?: faceapi.FaceMatcher;
  private readonly distanceThreshold = 0.5;
  private label: string;
  ready = false;
  private readonly descriptors: Float32Array[];

  constructor({ label, descriptors }: IFacial) {
    this.label = label;
    this.descriptors = descriptors;
  }

  async init() {
    await this.initFaceMatch();
    this.ready = true;
  }

  async initFaceMatch() {
    const labeledFaceDescriptors = await this.loadLabeledFaceDescriptors();
    this.faceMatcher = new faceapi.FaceMatcher(
      labeledFaceDescriptors,
      this.distanceThreshold
    );
  }

  async loadLabeledFaceDescriptors() {
    const results: faceapi.LabeledFaceDescriptors[] = [];
    const descriptors = this.descriptors.map(
      (descriptor) => new Float32Array(descriptor)
    );
    const result = new faceapi.LabeledFaceDescriptors(this.label, descriptors);
    results.push(result);
    return results;
  }

  async match(
    video: HTMLVideoElement,
    displaySize: { width: number; height: number }
  ) {
    const detections = await faceapi
      .detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks()
      .withFaceDescriptors();

    const resizedDetections = faceapi.resizeResults(detections, displaySize);
    const matches: IFaceMatch[] = [];

    resizedDetections.forEach((detection) => {
      const faceMatches = this.faceMatcher?.findBestMatch(detection.descriptor);
      //   canvas?.getContext("2d")?.clearRect(0, 0, canvas.width, canvas.height);
      if (faceMatches) {
        matches.push({
          match: faceMatches,
          detection,
        });
      }
    });

    return matches;
  }

  setCanvas(video: HTMLVideoElement) {
    // this.canvas = faceapi.createCanvasFromMedia(video);
    // const videoContainer = document.getElementById('video-container');
    // // This will force the use of a software (instead of hardware accelerated)
    // // Enable only for low configurations
    // (this.canvas as any).willReadFrequently = true;
    // videoContainer?.appendChild(this.canvas);
    // const canvasSize = { width: video.width, height: video.height };
    // faceapi.matchDimensions(this.canvas, canvasSize);
  }
}
